function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 136,
  y: 102,
  width: 34,
  height: 34,
  transform: "rotate(-180 136 102)",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 102,
  y: 102,
  width: 34,
  height: 34,
  transform: "rotate(-180 102 102)",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: 68,
  y: 102,
  width: 34,
  height: 34,
  transform: "rotate(-180 68 102)",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: 170,
  y: 68,
  width: 34,
  height: 34,
  transform: "rotate(-180 170 68)",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: 34,
  y: 68,
  width: 34,
  height: 34,
  transform: "rotate(-180 34 68)",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 136,
  y: 68,
  width: 34,
  height: 34,
  transform: "rotate(-180 136 68)",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 102,
  y: 68,
  width: 34,
  height: 34,
  transform: "rotate(-180 102 68)",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  x: 68,
  y: 68,
  width: 34,
  height: 34,
  transform: "rotate(-180 68 68)",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: 204,
  y: 34,
  width: 34,
  height: 34,
  transform: "rotate(-180 204 34)",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  x: 170,
  y: 34,
  width: 34,
  height: 34,
  transform: "rotate(-180 170 34)",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  x: 34,
  y: 34,
  width: 34,
  height: 34,
  transform: "rotate(-180 34 34)",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 136,
  y: 34,
  width: 34,
  height: 34,
  transform: "rotate(-180 136 34)",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 102,
  y: 34,
  width: 34,
  height: 34,
  transform: "rotate(-180 102 34)",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 34,
  y: 102,
  width: 34,
  height: 34,
  transform: "rotate(-180 34 102)",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.6,
  x: 68,
  y: 34,
  width: 34,
  height: 34,
  transform: "rotate(-180 68 34)",
  fill: "white"
});

var SvgJingge = function SvgJingge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 103,
    viewBox: "0 0 204 103",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJingge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jingge.eb7b08a2.svg";
export { ForwardRef as ReactComponent };